// src/Router.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { HomePage } from './Home/HomePage';
import { Navbar } from './NavBar/Navbar';
import { Fotter } from './Fotter/Fotter';
import { Notfoundpage } from './NotFound/Notfoundpage';
import { EnventsPage } from './Eventspage/EnventsPage';
import { Careers } from './careers/Careers';
import { Contact } from './Contact/Contact';
import { AboutPages } from './About/AboutPages';
import { Services } from './About/Services';
import { ProductsPage } from './Products/ProductsPage';
import i18n from './i18';

const Wrapper = ({ children }) => {
  const location = useLocation();
  const language = i18n.language;

  // Apply padding ONLY when NOT on "/"
  const isHome = location.pathname === "/";

  return (
    <div
      dir={`${language === 'en' || language === 'en-us' ? 'ltr' : 'rtl'}`}
      className={`${language === 'en' || language === 'en-us'
        ? 'font-serif'
        : 'font-speda'
        } ${!isHome ? 'pt-24' : ''}`}
    >
      {children}
    </div>
  );
};

const AppRouter = () => {
  return (
    <Router>
      <Navbar />
      <Wrapper>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/events" element={<EnventsPage />} />
          <Route path="/career" element={<Careers />} />
          <Route path="/about" element={<AboutPages />} />
          <Route path="/service" element={<Services />} />
          <Route path="/product" element={<ProductsPage />} />
          <Route path="*" element={<Notfoundpage />} />
        </Routes>
        <Fotter />
      </Wrapper>
    </Router>
  );
};

export default AppRouter;
